import { PresetStatusColorType } from 'antd/lib/_util/colors';

import { MemoSeverity } from '../graphql.generated';

export const NotificationSeverityLabel = {
  [MemoSeverity.Info]: 'Info',
  [MemoSeverity.Critical]: 'Critical',
  [MemoSeverity.Warn]: 'Warning',
};

export const NotificationSeverityColor: Record<
  MemoSeverity,
  PresetStatusColorType
> = {
  [MemoSeverity.Info]: 'processing',
  [MemoSeverity.Critical]: 'error',
  [MemoSeverity.Warn]: 'warning',
};
